import ApiClient from '@services/ApiClient';

export default {
    list(params) {
        return ApiClient.get('/consents');
    },
};
